import { useHistory } from 'react-router-dom'
import { useState, useReducer, useEffect } from 'react'
import swal from 'sweetalert'
import Action from '../../model/Action'
import { Entidade } from '../../model/Entidade'
import FormState from '../../model/FormState'
import Localizacao from '../../model/Localizacao'
import TipoEntidade from '../../model/TipoEntidade'
import { useProvider } from '../../provider/Provider'
import EntidadeService from '../../services/EntidadeService'

export default function useFormState() {
    const [formState, dispatch] = useReducer(reducer, initialState)
    const [tipoEntidades, setTipoEntidades] = useState<TipoEntidade[]>([])
    const { loadEntidades } = useProvider()
    const history = useHistory()

    useEffect(() => {
        EntidadeService.getTipoEntidades().then((data) => {
            setTipoEntidades(data)
        })
    }, [])

    useEffect(() => {
        if (formState.logo) {
            handleSubmit()
        }
    }, [formState.logo])

    function optionToTipoEntidade(list: any[]): TipoEntidade[] {
        return list.map((l) => {return { id: l.id, nome: l.name }})
    }

    const handleSubmit = () => {
        const newLocalizacao: Localizacao = {
            logradouro: formState.logradouro,
            numero: +formState.numero,
            bairro: formState.bairro,
            cidade: formState.cidade,
            complemento: formState.complemento
        }

        const entidade: Entidade = {
            nome: formState.nome,
            telefone: formState.telefone,
            site: formState.site,
            email: formState.email,
            descricao: formState.descricao,
            areaDeAtuacao: formState.areaDeAtuacao,
            localizacao: newLocalizacao,
            tipoEntidade: optionToTipoEntidade(formState.tipoEntidade),
            fase: formState.fase!,
            faturamento: +formState.faturamento!,
            logo: formState.logo,
            metas: formState.metas,
            pitch: formState.pitch,
            tamanhoEquipe: +formState.tamanhoEquipe!,
            publicoAlvo: formState.publicoAlvo!
        }

        EntidadeService.save(entidade).then(() => {
            loadEntidades()

            swal({
                title: 'Cadastro realizado com Sucesso!',
                icon: 'success',
                buttons: [false],
                timer: 2000
            })
            history.push('/buscar')
        }).catch(() => {
            swal({
                title: 'Falha no cadastro!',
                icon: 'error',
                buttons: [false],
                timer: 2000
            })
        })
    }

    return {
        tipoEntidades,
        formState,
        dispatch
    }
}

const reducer = (formState: FormState, action: Action): FormState => {
    switch (action.type) {
    case 'setNome':
        return { ...formState, nome: action.payload }
    case 'setTelefone':
        return { ...formState, telefone: action.payload }
    case 'setSite':
        return { ...formState, site: action.payload }
    case 'setEmail':
        return { ...formState, email: action.payload }
    case 'setDescricao':
        return { ...formState, descricao: action.payload }
    case 'setAreaDeAtuacao':
        return { ...formState, areaDeAtuacao: action.payload }
    case 'setCidade':
        return { ...formState, cidade: action.payload }
    case 'setBairro':
        return { ...formState, bairro: action.payload }
    case 'setLogradouro':
        return { ...formState, logradouro: action.payload }
    case 'setNumero':
        return { ...formState, numero: action.payload }
    case 'setComplemento':
        return { ...formState, complemento: action.payload }
    case 'setTipoEntidade':
        return { ...formState, tipoEntidade: action.payload }
    case 'setImagem':
        return { ...formState, image: action.payload }
    case 'setLogo':
        return { ...formState, logo: action.payload }
    case 'setPublicoAlvo':
        return { ...formState, publicoAlvo: action.payload }
    case 'setTamanhoEquipe':
        return { ...formState, tamanhoEquipe: action.payload }
    case 'setFaturamento':
        return { ...formState, faturamento: action.payload }
    case 'setMetas':
        return { ...formState, metas: action.payload }
    case 'setPitch':
        return { ...formState, pitch: action.payload }
    case 'setFase':
        return { ...formState, fase: action.payload }
    default:
        return formState
    }
}

const initialState: FormState = {
    nome: '',
    telefone: '',
    site: '',
    email: '',
    descricao: '',
    areaDeAtuacao: [],
    cidade: '',
    bairro: '',
    logradouro: '',
    numero: '',
    complemento: '',
    tipoEntidade: [],
    logo: '',
    metas: '',
    pitch: ''
}
